import { render, staticRenderFns } from "./Protocol.vue?vue&type=template&id=05182489&scoped=true&"
var script = {}
import style0 from "./Protocol.vue?vue&type=style&index=0&id=05182489&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05182489",
  null
  
)

export default component.exports